import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpalgharmidc() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Palghar MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Palghar MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Corporate Cab Service in Palghar MIDC, catering to the transportation needs of industrial units, manufacturing plants, and corporate offices in the region. Our fleet of well-maintained sedans, SUVs, and executive vehicles ensures safe, comfortable, and timely travel for employees, supervisors, clients, and senior management. Whether it is daily staff commute, plant visits, airport transfers, business meetings, or VIP travel, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Palghar MIDC.',

    top: 'Top Places to Visit in Navi Palghar with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Arnala Fort",
    "description": "Arnala Fort is a historic coastal fort located on Arnala Island, just off the Palghar coast. Built by the Portuguese and later occupied by the Marathas, the fort features impressive walls, bastions, and a lighthouse. Visitors can enjoy panoramic views of the Arabian Sea, explore the ruins, and experience the serenity of the island. The nearby beaches make it a perfect spot for photography, history enthusiasts, and a quiet weekend getaway."
  },
  {
    "title": "Tungareshwar Wildlife Sanctuary",
    "description": "Tungareshwar Wildlife Sanctuary is a lush forested area spread across the Western Ghats near Palghar. The sanctuary is home to diverse flora and fauna, including leopards, birds, and reptiles. Trekking trails, scenic viewpoints, and the Tungareshwar Mahadev Temple attract nature lovers and adventure seekers. Monsoon brings a fresh green cover, small waterfalls, and misty landscapes, making it ideal for trekking, hiking, and wildlife photography."
  },
  {
    "title": "Shirgaon Beach",
    "description": "Shirgaon Beach is a quiet and picturesque coastal spot near Palghar, known for its clean sands, gentle waves, and peaceful ambiance. Unlike the crowded city beaches, Shirgaon offers a serene escape for picnics, morning walks, beach photography, and family outings. The sunset views here are particularly captivating, attracting photographers and couples seeking a tranquil seaside experience."
  },
  {
    "title": "Kelva Beach",
    "description": "Kelva Beach is one of Palghar’s most popular beaches, offering long stretches of golden sand, coconut groves, and scenic views of the Arabian Sea. It is a favorite destination for swimming, beach walks, and weekend getaways. The beach also has several local food stalls and small resorts nearby, making it convenient for day trips and short vacations. During monsoon, the surrounding greenery enhances the beach’s charm."
  },
  {
    "title": "Dahanu Beach",
    "description": "Dahanu Beach, located near Palghar, is famous for its long coastline, peaceful environment, and proximity to the local fishing villages. The beach is ideal for sunrise and sunset views, leisurely walks, and enjoying fresh seafood from nearby stalls. Dahanu also hosts seasonal festivals and cultural events, offering visitors a glimpse into the local lifestyle and traditions."
  },
  {
    "title": "Palghar Fort (Vasai Creek Side)",
    "description": "Palghar Fort, also known as Fort Vasai, is a historical site that showcases remnants of Portuguese and Maratha architecture. Located near the Vasai Creek, the fort provides panoramic views of surrounding landscapes and the creek. Visitors can explore the ruins, enjoy the coastal breeze, and experience a mix of history, culture, and nature in a tranquil setting."
  },
  {
    "title": "Dahanu Mango Orchards",
    "description": "Palghar and nearby Dahanu are famous for their lush mango orchards, particularly the Alphonso variety. Seasonal visits allow travelers to explore sprawling farms, witness mango harvesting, and enjoy fresh mangoes straight from the trees. These orchards provide a delightful agro-tourism experience and are a must-visit for fruit lovers and families seeking a scenic countryside outing."
  },
  {
    "title": "Shirsad Beach",
    "description": "Shirsad Beach is a lesser-known, peaceful beach near Palghar, ideal for visitors looking for solitude and natural beauty. With golden sands, gentle waves, and sparse crowds, it offers opportunities for photography, meditation, and relaxed walks. The surrounding greenery and clean shoreline make it an ideal spot to escape the busy city life."
  },
  {
    "title": "Vasai Creek and Mangrove Trails",
    "description": "Vasai Creek near Palghar is surrounded by mangroves, creating a natural ecosystem for birds and aquatic life. Visitors enjoy boating, bird watching, and exploring the scenic trails along the creek. The area provides a calm and green environment for eco-tourism, nature photography, and relaxing evening outings with family and friends."
  },
  {
    "title": "Tarapur Industrial Area Viewpoints",
    "description": "Though primarily industrial, the Tarapur region near Palghar offers interesting viewpoints overlooking sprawling factories, greenery, and connecting highways. These spots are often visited by travelers and photography enthusiasts to capture the unique blend of industrial landscapes with distant natural scenery. It highlights Palghar’s evolving balance between industry and nature."
  }
],


"services": [
{
"name": "Palghar MIDC Employee Cab",
"description": "Palghar MIDC Employee Cab provides structured and reliable transportation for employees working in Palghar MIDC. The service features trained drivers, GPS-enabled vehicles, optimized routes, and multi-shift scheduling to ensure safe, punctual, and comfortable commuting for corporate and industrial staff across all shifts."
},
{
"name": "Worker Transport Palghar",
"description": "Worker Transport Palghar offers dependable pickup and drop services for factory and industrial employees. The service ensures timely commuting with trained chauffeurs, GPS-enabled vehicles, structured routes, and multi-shift support for smooth and safe daily operations."
},
{
"name": "Company Shuttle Palghar",
"description": "Company Shuttle Palghar delivers organized multi-passenger shuttle services for offices, industrial units, and corporate parks. With GPS-monitored vehicles, professional drivers, structured routes, and multi-shift support, the service ensures efficient, safe, and timely employee transportation across Palghar MIDC."
},
{
"name": "Business Cab Palghar MIDC",
"description": "Business Cab Palghar MIDC provides professional corporate taxi services for executives, office staff, and client visits. The service features trained chauffeurs, GPS monitoring, well-maintained vehicles, and optimized routes to ensure safe, comfortable, and punctual commuting for all business needs."
},
{
"name": "Affordable Corporate Cabs Palghar",
"description": "Affordable Corporate Cabs Palghar offers budget-friendly corporate and employee transportation solutions. The service includes well-maintained vehicles, professional drivers, GPS tracking, structured schedules, and reliable pickups for safe, timely, and cost-effective commuting."
},
{
"name": "Monthly Cab Palghar",
"description": "Monthly Cab Palghar provides long-term cab rental solutions for companies requiring consistent employee transportation. The service includes fixed monthly plans, trained drivers, GPS-enabled vehicles, structured routes, and punctual daily pickups for efficient and hassle-free commuting."
},
{
"name": "Best Corporate Cabs Palghar",
"description": "Best Corporate Cabs Palghar delivers premium corporate transportation services for office employees, managers, and industrial staff. The service ensures professional drivers, GPS-enabled vehicles, structured routes, optimized schedules, and well-maintained sedans and SUVs for reliable and comfortable commuting."
},
{
"name": "Office Pickup Drop Palghar",
"description": "Office Pickup Drop Palghar provides organized daily pickup and drop services for employees working in offices, IT parks, and industrial units. The service emphasizes punctuality, trained drivers, GPS tracking, and structured schedules to ensure safe and efficient commuting."
},
{
"name": "Staff Shuttle Palghar MIDC",
"description": "Staff Shuttle Palghar MIDC offers reliable shuttle services for employees working in industrial units and corporate offices. The service features multi-passenger vans, GPS-enabled tracking, trained drivers, optimized routes, and multi-shift support for safe and timely transportation."
},
{
"name": "Outstation Cab Palghar",
"description": "Outstation Cab Palghar provides long-distance transport solutions for corporate employees and business travelers. The service includes trained drivers, GPS-enabled vehicles, comfortable seating, and optimized routes to ensure safe, punctual, and hassle-free intercity commuting."
},
{
"name": "Sedan Cab Palghar",
"description": "Sedan Cab Palghar provides premium sedans for corporate executives, office employees, and business travel. The service ensures professional drivers, GPS tracking, punctual pickups, and well-maintained vehicles for safe, comfortable, and reliable commuting."
},
{
"name": "SUV Cab Palghar",
"description": "SUV Cab Palghar offers spacious and comfortable SUVs for team travel, industrial staff transport, and corporate commuting. The service includes trained drivers, GPS-enabled vehicles, structured routes, and multi-shift support for safe and efficient transportation."
},
{
"name": "Corporate Fleet Palghar",
"description": "Corporate Fleet Palghar provides fully managed corporate fleet solutions including sedans, SUVs, and staff cabs. The service covers vehicle maintenance, driver management, GPS monitoring, and structured routes to ensure seamless, safe, and efficient employee commuting."
},
{
"name": "Industrial Cab Palghar",
"description": "Industrial Cab Palghar specializes in transporting large numbers of employees for factories and industrial units. The service features trained drivers, GPS-enabled vehicles, structured routes, and multi-shift support to ensure organized, safe, and timely daily commuting."
},
{
"name": "Employee Commute Palghar",
"description": "Employee Commute Palghar offers structured transportation for office and industrial employees. The service includes GPS-enabled vehicles, trained drivers, optimized routes, multi-shift support, and timely pickups and drop-offs to ensure safe, efficient, and comfortable daily commuting."
}
],

"tableData": [
["Palghar MIDC Employee Cab", "Worker Transport Palghar"],
["Company Shuttle Palghar", "Business Cab Palghar MIDC"],
["Affordable Corporate Cabs Palghar", "Monthly Cab Palghar"],
["Best Corporate Cabs Palghar", "Office Pickup Drop Palghar"],
["Staff Shuttle Palghar MIDC", "Outstation Cab Palghar"],
["Sedan Cab Palghar", "SUV Cab Palghar"],
["Corporate Fleet Palghar", "Industrial Cab Palghar"],
["Employee Commute Palghar", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Palghar MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Palghar MIDC, ensuring smooth and efficient transportation for business employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drop-offs, helping employees reach offices, industrial zones, and business hubs in Palghar MIDC without any delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible corporate cab rental plans tailored to meet the commuting requirements of businesses and employees in Palghar MIDC."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]
























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Palghar MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees in Palghar MIDC.',
  },
  {
    question: 'What types of corporate cab services are available in Palghar MIDC?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for industrial areas.',
  },
  {
    question: 'Do you support daily commuting for employees in Palghar MIDC?',
    answer: 'Yes, we provide optimized daily commute solutions with timely pickups and flexible shift scheduling for corporate clients in Palghar MIDC.',
  },
  {
    question: 'How can companies book corporate cab services in Palghar MIDC?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Palghar MIDC?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Palghar MIDC?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Palghar MIDC?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashwin Thakur',
    feedback: 'Highly reliable corporate cab service in Palghar MIDC. Punctual, safe, and professional for our employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Deepa Nair',
    feedback: 'Excellent corporate transportation service in Palghar MIDC. Smooth operations and professional drivers.',
    rating: 5,
  },
];































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Palghar MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-palghar-midc.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Palghar MIDC, including employee transportation, worker commutes, staff shuttles, company cab services, office pickup & drop, monthly cab plans, industrial area transport, outstation trips, and chauffeur-driven executive vehicles for companies operating in Palghar MIDC.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-palghar-midc"
  }
};






  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Palghar MIDC | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Palghar MIDC including employee transport, worker commutes, staff shuttles, office pickup & drop, company cabs, monthly cab plans, industrial cabs, outstation trips, and chauffeur-driven executive vehicles for companies in Palghar MIDC."
  />

  <meta
    name="keywords"
    content="Palghar MIDC Employee Cab, Worker Transport Palghar, Company Shuttle Palghar, Business Cab Palghar MIDC, Affordable Corporate Cabs Palghar, Monthly Cab Palghar, Best Corporate Cabs Palghar, Office Pickup Drop Palghar, Staff Shuttle Palghar MIDC, Outstation Cab Palghar, Sedan Cab Palghar, SUV Cab Palghar, Corporate Fleet Palghar, Industrial Cab Palghar, Employee Commute Palghar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpalgharmidc;